/**
 * THE HOLDER A PAGE READS THROUGH (VC-core's ruling; VC-Authz's holder
 * context, middleware `x-holder-island`). A record a project references is
 * read at that project's pin — on the page, on REST, by an agent — only when
 * the request names the holder; a REST read that does not is answered at the
 * referenced island's head (PIN-02: A's page showed B's newer name after a
 * REST read).
 *
 * The project shell binds its project while one of its pages is mounted;
 * every READ sends `x-holder-island` then (`readHolderHeaders`): a registered
 * query, a GET. Never a write (VC-core: a write binds no coordinates; the
 * server's link writers would also refuse a link whose ends exclude the named
 * holder). A picker that ADDS a link reads at head instead (`apiFetchAtHead`):
 * the new link pins what the user picked, at head. Selection is not
 * authorization: the server judges every read as before.
 */

let holder: string | null = null;

export function setActiveHolder(islandId: string): void {
  holder = islandId || null;
}

/** Clear the binding — only `islandId`'s, so a later page's is kept. */
export function clearActiveHolder(islandId: string): void {
  if (holder === islandId) holder = null;
}

export function activeHolder(): string | null {
  return holder;
}

export function holderHeaders(): Record<string, string> {
  return holder ? { "x-holder-island": holder } : {};
}

/** A read: a GET, or a registered query (POST /api/query). */
export function isRead(path: string, init: { method?: string } = {}): boolean {
  const method = (init.method ?? "GET").toUpperCase();
  return method === "GET" || method === "HEAD" || (method === "POST" && /\/api\/query(\?|$)/.test(path));
}

/** The holder header for a READ from a holder's page; nothing for a write. */
export function readHolderHeaders(path: string, init: { method?: string } = {}): Record<string, string> {
  return isRead(path, init) ? holderHeaders() : {};
}
